import { createFileRoute, Navigate } from "@tanstack/react-router";
import { LoaderIcon } from "lucide-react";

import { CapabilitiesSettings } from "../components/settings/CapabilitiesSettings";
import { useAdministrativeAccess } from "../components/settings/useAdministrativeAccess";

function SettingsCapabilitiesRoute() {
  const { canWrite, isPending } = useAdministrativeAccess();
  if (isPending) {
    return (
      <div className="flex flex-1 items-center justify-center text-muted-foreground/40">
        <LoaderIcon className="size-4 animate-spin" />
      </div>
    );
  }
  if (!canWrite) {
    return <Navigate to="/settings/general" replace />;
  }
  return <CapabilitiesSettings />;
}

export const Route = createFileRoute("/settings/capabilities")({
  component: SettingsCapabilitiesRoute,
});
